module.exports = __webpack_public_path__ + "img/o_7.44ea0b1c.png";